import { baseUrl } from "../utils/baseUrl";
import jwtInterceoptor from "./autorizacao/jwt-interceptor";

class ServicosImagens {

    create(id_produto, files) {
        const formData = new FormData();
        formData.append("id_produto", id_produto);
        for (let i = 0; i < files.length; i++) {
          formData.append('file', files[i]);
        }
        return jwtInterceoptor.post(`${baseUrl}/uploadImagem`, formData)
    }

    listarTodas() {
      return jwtInterceoptor.get(`${baseUrl}/uploadImagem`);
    }
    listarPorIdProduto(id) {
      return jwtInterceoptor.get(`${baseUrl}/uploadImagem/${id}`);
    }
    deleteImagem(id) {
      return jwtInterceoptor.delete(`${baseUrl}/uploadImagem/${id}`);
    }

}

export default new ServicosImagens();